import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Card, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import PsContext from "../../../context";
import { DB_POSTFIX } from "../../../utils";
import { ServiceUrl } from "../../../utils/serviceUrl";
import AdmissionModel from "./AdmissionModel";

const Footer = (props) => {
  const context = useContext(PsContext);
  const [quickLinks, setQuickLinks] = useState([]);

  useEffect(() => {
    LoadData();
  }, []);

  const LoadData = () => {
    axios.get(ServiceUrl.LINKS + "?sadb=" + DB_POSTFIX).then((res) => {
      if (res["data"].status == "1") setQuickLinks(res["data"].data);
    });
  };

  return (
    <>
      <AdmissionModel />
      <section className="footer new-footer">
        <div className="container">
          <div className="wed-foot-link ">
            <div className="row ">
              <Col md={4}>
                <div className="footer-widget-box list">
                  <h4 className="footer-widget-title">Information</h4>
                  <ul>
                    <li>
                      <a href="#" className="fw-bold text-white">
                        {context.settingValue("web_site_name")}
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i
                          className="fa fa-map-marker-alt p-2 me-2 fs-6"
                          style={{
                            backgroundColor: "#fff",
                            color: "#0d80ba",
                            borderRadius: "20px",
                          }}
                        ></i>
                        {context.settingValue("web_site_address_line1")}
                        {", "} {context.settingValue("web_site_address_city")}
                        {", "}
                        {context.settingValue("web_site_address_state")}
                        {", "}
                        {context.settingValue("web_site_address_country")}
                        {" - "}
                        {context.settingValue("web_site_address_pincode")}
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i
                          className="fa fa-phone me-2 p-2 fs-6"
                          style={{
                            backgroundColor: "#fff",
                            color: "#0d80ba",
                            borderRadius: "20px",
                          }}
                        ></i>
                        {context.settingValue("web_site_enquiry_phone")}{" "}
                        {context.settingValue("web_site_enquiry_mobile")}
                      </a>
                    </li>

                    <li className="text-white">
                      <i
                        className="fa fa-envelope me-2 p-2 fs-6"
                        style={{
                          backgroundColor: "#fff",
                          color: "#0d80ba",
                          borderRadius: "20px",
                        }}
                      ></i>
                      <a
                        href={`mailto:${context.settingValue(
                          "web_site_enquiry_email"
                        )}`}
                        className="text-white"
                      >
                        {context.settingValue("web_site_enquiry_email")}
                      </a>
                    </li>
                  </ul>
                </div>
              </Col>

              <Col md={2}>
                <div className="footer-widget-box list">
                  <h4 className="footer-widget-title">Social Links</h4>
                  <ul>
                    <li className="text-white">
                      <i className="fab fa-facebook me-2"></i>
                      <a
                        href={context.settingValue("web_site_social_facebook")}
                        className="text-white"
                      >
                        Facebook
                      </a>
                    </li>
                    <li className="text-white">
                      <i class="fa-brands fa-twitter me-2"></i>
                      <a
                        href={context.settingValue("web_site_social_twitter")}
                        className="text-white"
                      >
                        Twitter-X
                      </a>
                    </li>

                    <li className="text-white">
                      <i className="fab fa-instagram me-2"></i>
                      <a
                        href={context.settingValue("web_site_social_instagram")}
                        className="text-white"
                      >
                        Instagram
                      </a>
                    </li>

                    <li className="text-white">
                      <i className="fab fa-youtube me-2"></i>
                      <a
                        href={context.settingValue("web_site_social_youtube")}
                        className="text-white"
                      >
                        Youtube
                      </a>
                    </li>
                    <li>
                      <a href="https://wa.me/" target="_blank">
                        <i class="fab fa-whatsapp me-2"></i>
                        Whatsapp
                      </a>
                    </li>
                  </ul>
                </div>
              </Col>

              <Col md={2}>
                <div className="footer-widget-box list">
                  <h4 className="footer-widget-title">Quick Links</h4>
                  <ul class="footer-list">
                    <li>
                      <a href="https://dbcmaram.ac.in/">
                        <i class="fas fa-caret-right me-2"></i> Home
                      </a>
                    </li>
                    <li>
                      <a href="/present-year">
                        <i class="fas fa-caret-right me-2"></i>
                        History
                      </a>
                    </li>
                    <li>
                      <a href="/management">
                        <i class="fas fa-caret-right me-2"></i>Administration
                      </a>
                    </li>
                    <li>
                      <a href="/target-setting">
                        <i class="fas fa-caret-right me-2"></i>
                        Academics
                      </a>
                    </li>
                    <li>
                      <a href="/timetable">
                        <i class="fas fa-caret-right me-2"></i> Exams
                      </a>
                    </li>
                  </ul>
                </div>
              </Col>

              <Col md={4}>
                <div className="footer-widget-box list">
                  <h4 className="footer-widget-title">Services</h4>
                  <ul class="footer-list">
                    <div className="row">
                      <div className="col-lg-6">
                        <ul>
                          <li>
                            <a href="/clubs">
                              <i class="fas fa-caret-right me-2"></i>
                              Club
                            </a>
                          </li>

                          <li>
                            <a href="/ignou" target="_blank">
                              <i class="fas fa-caret-right me-2"></i>IGNOU
                            </a>
                          </li>
                          <li>
                            <a href="/add-on-courses">
                              <i class="fas fa-caret-right me-2"></i>Add on
                              Course
                            </a>
                          </li>
                          <li>
                            <a href="/association">
                              <i class="fas fa-caret-right me-2"></i>
                              Association
                            </a>
                          </li>
                          <li>
                            <a href="/administration" target="_blank">
                              <i class="fas fa-caret-right me-2"></i>
                              Administration
                            </a>
                          </li>
                        </ul>
                      </div>

                      <div className="col-lg-6">
                        <ul>
                          <li>
                            <a href="/research">
                              <i class="fas fa-caret-right me-2"></i> Research
                            </a>
                          </li>
                          <li>
                            <a href="/feed-back">
                              <i class="fas fa-caret-right me-2"></i>
                              Feed Back
                            </a>
                          </li>
                          <li>
                            <a href="/library">
                              <i class="fas fa-caret-right me-2"></i>
                              Library
                            </a>
                          </li>
                          <li>
                            <a href="/infrastructure">
                              <i class="fas fa-caret-right me-2"></i>
                              Infrastructure
                            </a>
                          </li>
                          <li>
                            <a href="/achievements">
                              <i class="fas fa-caret-right me-2"></i>
                              Achievements
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </ul>
                </div>
              </Col>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
